import { actionsFactory, props } from '@ngneat/effects';

import { VidyardHelpVideo } from './vidyard.repository';

const vidyardActions = actionsFactory('vidyard');

export const setCurrentHelpVideo = vidyardActions.create(
  'Set Current Help Video',
  props<{ video: VidyardHelpVideo }>()
);
